import Drawer from 'components/drawer/Drawer';
import { bindMethod } from 'helpers/bind';
import { forceArray } from 'navigation/component/Component';
class ProductSizeSelector extends Drawer {
    tab = 0;
    constructor(el, options) {
        super(el, options);
        this.name = el.dataset.drawerIndex ? `size-selector-${el.dataset.drawerIndex}` : 'size-selector';
        this.params = {
            desktop: {
                axis: 'X',
                direction: 'reversed'
            },
            mobile: {
                axis: 'Y',
                direction: 'reversed'
            }
        };
    }
    initialized() {
        super.initialized();
        if (this.refs.productSizeConfirmDiv)
            this.el.style.setProperty('--size-confirm-height', `${this.refs.productSizeConfirmDiv.offsetHeight}px`);
        this.el.style.setProperty('--size-header-height', `${this.refs.productSizeHeader.offsetHeight}px`);
    }
    toggle(value) {
        super.toggle(value);
        // const lockMethod = value ? 'lock' : 'unlock'
        // scroll[lockMethod](true)
    }
    bindEvents(add = true) {
        super.bindEvents(add);
        const method = bindMethod(add);
        forceArray(this.refs.productSizeRadios).forEach((radio) => {
            if (radio !== undefined)
                radio[method]('change', this.onRadioChange);
        });
        if (this.refs.sizeSwitchTab) {
            forceArray(this.refs.sizeSwitchTab).forEach((tab, i) => {
                if (tab !== undefined)
                    tab[method]('click', () => this.onTabClick(i));
            });
        }
    }
    onTabClick = (index, force = false) => {
        if (this.refs.sizeSwitchTab === undefined)
            return;
        this.refs.sizeSwitchTab.forEach((tab, i) => {
            tab.classList.toggle('active', index === i);
        });
        this.refs.sizeTabs.classList.toggle('forced', force);
        this.refs.sizeTabs.dataset.active = index.toString();
        this.emit('tab:change', index);
        this.tab = index;
    };
    onRadioChange = (event) => {
        const target = event.currentTarget;
        const field = target.dataset.field || target.name;
        if (this.refs.sizeTabLabels)
            this.refs.sizeTabLabels.find(label => label.dataset.inputName === field).textContent = target.dataset.label;
        this.emit('change', {
            [field]: target.value,
            label: target.dataset.label
        });
    };
    resize() {
        super.resize();
        this.el.style.setProperty('--size-header-height', `${this.refs.productSizeHeader.offsetHeight}px`);
        if (this.refs.productSizeConfirmDiv)
            this.el.style.setProperty('--size-confirm-height', `${this.refs.productSizeConfirmDiv.offsetHeight}px`);
    }
    reset() {
        this.refs.productSizeRadios.forEach(radio => {
            radio.checked = false;
        });
    }
}
export default ProductSizeSelector;
